import script from "./CryptoTracker.vue?vue&type=script&setup=true&lang=js"
export * from "./CryptoTracker.vue?vue&type=script&setup=true&lang=js"

import "./CryptoTracker.vue?vue&type=style&index=0&id=31a4c23f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31a4c23f"]])

export default __exports__